export const GlobalConfig = {
    URL: 'https://sport-api-ufa.lnwthai.com',
    AGENT : 'ufuLnwff1',
    LINESUPPORT : 'https://lin.ee/ZAeexuz',
    LOGINURL: 'https://login.z1688.net/member/login-from-client',
    };